import {StyledMultiselectSelectedIconWrapper} from '../itemTemplates/templates'
import {styledInput} from 'components/Form/styles/FormView'

const INPUT_HEIGHT = 32
const RESULTS_MAX_HEIGHT = 340
const RESULT_ITEM_MIN_HEIGHT = 50

export const searchAutocompleteWrapper = {
    '& *': {boxSizing: 'border-box'},
    '& > div': {
        position: 'relative',
        width: '100%',
    },
    'color': '$searchAutocompleteText',
    'margin': '$searchAutocompleWrapperVertical 0',
    'minWidth': '200px',
}

export const searchAutocompleteResultsWrapper = {
    '> div': {
        backgroundColor: '$searchAutocompleteResults',
        border: '1px solid $searchAutocompleteBorder',
        borderBottomLeftRadius: '$searchAutocompleteBorder',
        borderBottomRightRadius: '$searchAutocompleteBorder',
        boxShadow: '0px 5px 10px $searchAutocompleteResultsBoxShadow',
        maxHeight: `${RESULTS_MAX_HEIGHT}px`,
        overflowY: 'auto',
    },
    'paddingBottom': '$searchAutocompleteResultsVertical',
    'position': 'absolute',
    'top': `${INPUT_HEIGHT - 1}px`,
    'variants': {hidden: {true: {display: 'none'}}},
    'width': '100%',
    'zIndex': '$searchAutocompleteResults',
}

export const searchAutocompleteInputWrapper = {
    alignItems: 'center',
    display: 'flex',
    position: 'relative',
}

export const searchAutocompleteInput = {
    ...styledInput,
    height: `${INPUT_HEIGHT}px`,
    margin: 0,
    variants: {
        isOpen: {
            true: {
                border: '1px solid $searchAutocompleteBorder',
                borderBottomLeftRadius: 0,
                borderBottomRightRadius: 0,
            },
        },
        showIcon: {true: {paddingLeft: '35px'}},
    },
    width: '100%',
}

export const searchAutocompleItems = {}

export const searchAutocompleteResultsButton = {
    '&&:focus': {
        background: '$searchAutocompleteResultHighlighted',
        borderRadius: '$searchAutocompleteBorder',
        outline: '2px solid $searchAutocompleteBorder',
        outlineOffset: -1,
    },
    '&&:hover': {
        [`&:not(:focus) ${StyledMultiselectSelectedIconWrapper}`]: {
            'svg:nth-child(1)': {display: 'none'},
            'svg:nth-child(2)': {display: 'block'},
        },
        background: '$searchAutocompleteResultHighlighted',
    },
    '&:nth-child(2n)': {background: '$searchAutocompleteResultOdd'},
    '> div': {padding: '$searchAutocompleteResultVertical $searchAutocompleteResultHorizontal'},
    'alignItems': 'center',
    'background': 'none',
    'border': 'none',
    'color': '$searchAutocompleteText',
    'display': 'flex',
    'fontSize': '$searchAutocompleteResultItemText',
    'minHeight': `${RESULT_ITEM_MIN_HEIGHT}px`,
    'padding': 0,
    'textAlign': 'left',
    'width': '100%',
}

export const searchAutocompleteResultsHeader = {
    fontSize: '$searchAutocompleterResultsHeaderText',
    fontWeight: 'bold',
    padding: '$searchAutocompleteResultsHeaderVertical $searchAutocompleteResultsHeaderHorizontal',
}

export const searchAutocompleteNoResults = {padding: '$searchAutocompleteNoResultsVertical $searchAutocompleteNoResultsHorizontal'}

export const inputIconWrapper = {
    '& svg': {width: '100%'},
    'left': '10px',
    'lineHeight': 0,
    'position': 'absolute',
    'top': '50%',
    'transform': 'translate(0, -50%)',
    'width': '20px',
}
